/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  document.querySelectorAll('.unit-btn').forEach(button => {
    button.addEventListener('click', () => {
      document.querySelectorAll('.unit-btn').forEach(btn => btn.classList.remove('active'));
      button.classList.add('active');

      const unit = button.dataset.unit;
      document.querySelectorAll('.size-table-container').forEach(tab => tab.classList.remove('active'));
      document.querySelector(`#table-${unit}`).classList.add('active');
    });
  });




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
